"use client";
import React from "react";
import { Sun } from "lucide-react";
import { blogData } from "../../blogs/data/blogData";
import BlogCard from "./BlogCard";
import Link from "next/link";
import { motion } from "framer-motion";

const Blogs = () => {
  const lastFourBlogs = blogData.blogs.slice(-4).reverse();

  return (
    <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: false }} className="flex flex-col gap-8 lg:justify-evenly my-[4rem] px-[1.5rem] sm:px-[3rem] lg:px-[6rem]">
      {/* Title and See All Button */}
      <div className="flex flex-col sm:flex-row gap-2 sm:justify-between sm:items-center">
        <div className="flex flex-col gap-3 mb-4">
          <div className="text-pri text-desc-size2 flex items-center gap-2">
            <Sun size={20} />
            <span>{blogData.title.mainTitle}</span>
          </div>
          <div className="text-text1 text-title-size3 lg:text-title-size2 md:w-[60vw] leading-[1]">
            {blogData.title.heading}
          </div>
        </div>
        <div className="flex">
          <Link href="/blogs" passHref>
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="flex items-center px-4 py-3 bg-pri rounded-md text-color4 text-desc-size2 cursor-pointer"
            >
              See All Blog Posts
            </motion.div>
          </Link>
        </div>
      </div>

      {/* Blog Cards Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 w-full max-w-screen-2xl self-center">
        {lastFourBlogs.map((blog) => (
          <Link
            key={blog.id}
            href={`/blogs/blogDetails/${blog.id}`}
            passHref
          >
            <motion.div
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
            >
              <BlogCard
                imageUrl={blog.imageUrl}
                date={blog.date}
                category={blog.category}
                title={blog.title}
                description={blog.description}
              />
            </motion.div>
          </Link>
        ))}
      </div>
    </motion.div>
  );
};

export default Blogs;
